/**
 * BgOrbs — декоративные мягкие радиальные orb-формы для фона сцены.
 * Чистый CSS, без анимаций (чтобы не отвлекать). Лёгкое дыхание добавляется
 * через keyframes на родителе при необходимости.
 *
 * Компонует 2-3 orb с разными цветами и размерами в фиксированных позициях.
 * Не интерактивно, aria-hidden. Pointer-events disabled.
 */
export default function BgOrbs({
  variant = 'soft',
}: {
  variant?: 'soft' | 'warm' | 'subtle';
}) {
  if (variant === 'subtle') {
    return (
      <div aria-hidden className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#dce5d9] opacity-50 blur-3xl" />
        <div className="absolute -bottom-40 -left-32 w-[380px] h-[380px] rounded-full bg-[#e7f0e5] opacity-60 blur-3xl" />
      </div>
    );
  }

  if (variant === 'warm') {
    return (
      <div aria-hidden className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/4 -left-40 w-[480px] h-[480px] rounded-full bg-[#b7102a] opacity-[0.06] blur-3xl" />
        <div className="absolute bottom-1/4 -right-40 w-[520px] h-[520px] rounded-full bg-[#dca85f] opacity-[0.08] blur-3xl" />
      </div>
    );
  }

  // soft (default)
  return (
    <div aria-hidden className="absolute inset-0 pointer-events-none overflow-hidden">
      <div className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full bg-[#b7102a] opacity-[0.05] blur-3xl" />
      <div className="absolute top-1/3 -right-32 w-[460px] h-[460px] rounded-full bg-[#5a7558] opacity-[0.10] blur-3xl" />
      <div className="absolute -bottom-32 left-1/3 w-[400px] h-[400px] rounded-full bg-[#dca85f] opacity-[0.06] blur-3xl" />
    </div>
  );
}
